import React from 'react';
import { Typography, RegularButton } from 'fronton-react';
import { cx } from 'linaria';
import { useTranslation } from 'react-i18next';
import { patchUrlByLocale } from 'utils';
import {
  suggestionContentWrap,
  suggestionTextContentWrap,
  suggestionButton,
  suggestion,
  suggestionText,
} from './suggestion-list-item-styles';
import { SuggestionsGaMetaInfo } from '../../types';
import { SuggestionListItemCategoryImage } from './suggestion-list-item-category-image';

const PROMO_URL = '/promo/';

const ICON_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/v1748500888/fudzi/navigation-microfronts/header/promo-icon.svg/promo-icon.svg';

export interface SuggestionListItemPromoPageProps {
  elementIndex: number;
  navigationIndex: number;
  isSrp: boolean;
  suggestionSelector: string;
  buttonAction: (
    id: number,
    linkToNavigate?: string,
    gaMeta?: SuggestionsGaMetaInfo,
  ) => React.HTMLAttributes<HTMLButtonElement>;
}

export const SuggestionListItemPromoPage = (props: SuggestionListItemPromoPageProps) => {
  const { isSrp, navigationIndex, elementIndex, buttonAction } = props;

  const { t } = useTranslation();

  return (
    <div role="option" aria-selected={elementIndex === navigationIndex} data-qa-header-search-suggestion="">
      <RegularButton
        variant="pseudo"
        tabIndex={-1}
        className={cx(suggestion, elementIndex === navigationIndex && 'active', isSrp && suggestionButton)}
        data-qa="suggestion-button"
        {...buttonAction(elementIndex, PROMO_URL, {
          block: t('header.promo.promo-block'),
          index: elementIndex,
          text: t('header.promo.promo-text'),
        })}
        href={patchUrlByLocale({ url: PROMO_URL })}
      >
        <div className={suggestionContentWrap}>
          <SuggestionListItemCategoryImage src={ICON_PATH} alt={t('header.promo.promo-text')} />
          <div className={suggestionTextContentWrap}>
            <Typography variant="m" size="body_short" className={suggestionText} color="text-primary">
              {t('header.promo.promo-text')}
            </Typography>
            <Typography variant="caption" color="text-secondary">
              {t('header.promo.promo-sales')}
            </Typography>
          </div>
        </div>
      </RegularButton>
    </div>
  );
};
